import styles from "./mapping.module.css";
import { useMappingDraft } from "./useMappingDraft";

export function StickySaveBar({ busy, onSave }: { busy: boolean; onSave(): void }) {
  const count = useMappingDraft((state) => Object.keys(state.dirtyRows).length);
  const discard = useMappingDraft((state) => state.discard);
  if (count === 0) return null;

  return (
    <div className={styles.saveBar} role="status">
      <strong>
        {count} unsaved change{count === 1 ? "" : "s"}
      </strong>
      <button type="button" className="btn btn-sm btn-ghost" onClick={discard} disabled={busy}>
        Discard
      </button>
      <button type="button" className="btn btn-sm btn-primary" onClick={onSave} disabled={busy}>
        Save draft
      </button>
    </div>
  );
}
